const SkeletonBlock = ({ className = "" }) => (
  <div className={`animate-pulse rounded-lg bg-gray-100 ${className}`} />
);

export default function DashboardOverviewSkeleton() {
  return (
    <div className="space-y-4" aria-label="در حال بارگذاری داشبورد" aria-busy="true">
      <div className="flex items-center justify-between gap-3">
        <div className="space-y-2">
          <SkeletonBlock className="h-6 w-32" />
          <SkeletonBlock className="h-4 w-40" />
        </div>
        <SkeletonBlock className="h-9 w-48" />
      </div>

      <SkeletonBlock className="h-16 w-full rounded-2xl" />

      <section className="grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-gray-100 bg-gray-100 md:grid-cols-5">
        {Array.from({ length: 5 }, (_, index) => (
          <div key={index} className={`bg-white px-4 py-3.5 ${index === 4 ? "col-span-2 md:col-span-1" : ""}`}>
            <SkeletonBlock className="h-3.5 w-20" />
            <SkeletonBlock className="mt-2.5 h-6 w-14" />
            <SkeletonBlock className="mt-2 h-3 w-24" />
          </div>
        ))}
      </section>

      <div className="grid gap-4 lg:grid-cols-[minmax(0,1fr)_20rem]">
        <section className="rounded-2xl border border-gray-100 bg-white p-4">
          <SkeletonBlock className="h-5 w-28" />
          <SkeletonBlock className="mt-4 h-12 w-full" />
          <SkeletonBlock className="mt-2 h-12 w-full" />
          <SkeletonBlock className="mt-2 h-12 w-full" />
        </section>
        <div className="space-y-4">
          {[0, 1].map((item) => (
            <section key={item} className="rounded-2xl border border-gray-100 bg-white p-4">
              <SkeletonBlock className="h-4 w-20" />
              <SkeletonBlock className="mt-3 h-10 w-full" />
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
